import React, { useEffect, useState } from 'react';
import { Check } from 'lucide-react';

/**
 * Small unobtrusive indicator that shows when the draft was last auto-saved.
 * - When `active` is false → renders nothing (auto-save is disabled).
 * - When `lastAutoSavedAt` is null but `active` → shows "Auto-save on".
 * - Otherwise shows "Autosaved · <relative>" and re-renders every 10s.
 */
export const AutoSaveIndicator = ({ lastAutoSavedAt, active }) => {
  const [, setTick] = useState(0);

  useEffect(() => {
    if (!active) return;
    const t = setInterval(() => setTick((n) => n + 1), 10000);
    return () => clearInterval(t);
  }, [active]);

  if (!active) return null;

  const label = lastAutoSavedAt ? `Autosaved · ${formatRelative(lastAutoSavedAt)}` : 'Auto-save on';

  return (
    <div
      className="inline-flex items-center gap-1.5 text-xs text-foreground/60"
      data-testid="autosave-indicator"
      title="Your changes are auto-saved every 15 seconds while this is in draft"
    >
      <Check className="w-3.5 h-3.5 text-primary" />
      <span>{label}</span>
    </div>
  );
};

function formatRelative(when) {
  const secs = Math.max(1, Math.floor((Date.now() - when.getTime()) / 1000));
  if (secs < 60) return 'just now';
  const mins = Math.floor(secs / 60);
  if (mins < 60) return `${mins} min ago`;
  const hrs = Math.floor(mins / 60);
  return `${hrs}h ago`;
}
